import store from '@/store/store'
import { ability } from '@/permissions/rules'

const getAgency = agencyId => store.dispatch('agency/getAgency', { agencyId })

const fetchAgency = async (to, from, next) => {
  const agencyId = to.params.agencyId
  try {
    await getAgency(agencyId)
    next()
  } catch (e) {
    if (ability.can('read', 'AllAgencies')) {
      next({ name: 'agencies' })
    } else {
      next({ name: 'agency' })
    }
  }
}

export default fetchAgency
